import { render, staticRenderFns } from "./NewsPanel.vue?vue&type=template&id=54114540&scoped=true"
import script from "./NewsPanel.vue?vue&type=script&lang=js"
export * from "./NewsPanel.vue?vue&type=script&lang=js"
import style0 from "./NewsPanel.vue?vue&type=style&index=0&id=54114540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54114540",
  null
  
)

export default component.exports